import Button from "components/common/Button/Button";
import ThreeDots from "components/common/Loader/ThreeDots";
import * as React from "react";

interface IProps {
  activating: boolean;
  activateBlockchainWallet(): void;
}

const ActivateBlockchainWallet: React.SFC<IProps> = ({
  activateBlockchainWallet,
  activating
}) => (
  <>
    {activating ? (
      <div
        style={{
          padding: "0px 62px"
        }}
      >
        <ThreeDots />
      </div>
    ) : (
      <Button primary onClick={activateBlockchainWallet}>
        Activate Blockchain Wallet
      </Button>
    )}
  </>
);
export default ActivateBlockchainWallet;



// WEBPACK FOOTER //
// ./src/screens/Main/edit-profile/blockchain/ActivateBlockchainWallet.tsx